export var SessionEvent;
(function (SessionEvent) {
    SessionEvent["Restored"] = "SessionEvent:SessionRestored";
    SessionEvent["Revoked"] = "SessionEvent:SessionRevoked";
    SessionEvent["UserKeyPairChanged"] = "SessionEvent:UserKeyPairChanged";
})(SessionEvent || (SessionEvent = {}));
